import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";

import Tienda from "./views/cliente/Tienda";
import PanelAdmin from "./views/admin/PanelAdmin";
import Login from "./views/cliente/Login";
import Carrito from "./views/cliente/Carrito";
import Checkout from "./views/cliente/Checkout";
import Perfil from "./views/cliente/Perfil";

import { auth, db } from "./firebase";

function RutaAdminProtegida({ children }) {
  const [verificando, setVerificando] = useState(true);
  const [esAdmin, setEsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (usuario) => {
      try {
        if (!usuario || !usuario.email) {
          setEsAdmin(false);
          setVerificando(false);
          return;
        }

        const adminsRef = collection(db, "admins");

        const q = query(
          adminsRef,
          where("email", "==", usuario.email),
          where("activo", "==", true),
        );

        const snapshot = await getDocs(q);

        setEsAdmin(!snapshot.empty);
      } catch (error) {
        console.error("Error verificando acceso admin:", error);
        setEsAdmin(false);
      } finally {
        setVerificando(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (verificando) {
    return (
      <div style={{ padding: "40px", textAlign: "center", fontWeight: "700" }}>
        Verificando acceso...
      </div>
    );
  }

  if (!esAdmin) {
    return <Navigate to="/login?admin=1" replace />;
  }

  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta principal: Tienda del cliente */}
        <Route path="/" element={<Tienda />} />

        {/* Ruta del Administrador protegida */}
        <Route
          path="/admin"
          element={
            <RutaAdminProtegida>
              <PanelAdmin />
            </RutaAdminProtegida>
          }
        />

        {/* Ruta del carrito */}
        <Route path="/carrito" element={<Carrito />} />

        {/* Ruta de Login y Registro */}
        <Route path="/login" element={<Login />} />

        {/* Ruta del proceso de pago */}
        <Route path="/checkout" element={<Checkout />} />

        {/* Ruta del perfil */}
        <Route path="/perfil" element={<Perfil />} />
      </Routes>
    </Router>
  );
}

export default App;
